export default __webpack_public_path__ + "static/media/tickets_Cancelled.89392f76.svg";